import {z} from '@hono/zod-openapi';

import {ISSUE_REPORT_DIAGNOSTICS_LIMITS as LIMITS} from './ISSUE_REPORT_DIAGNOSTICS_LIMITS';

export const issueReportAffectedRecordSchema = z
  .object({
    kind: z.enum(['businessCase', 'customer', 'interest', 'vehicle']),
    id: z.string().min(1).max(64),
    label: z.string().min(1).max(LIMITS.affectedRecordLabel).optional(),
    url: z.string().max(LIMITS.url).optional(),
  })
  .openapi('IssueReportAffectedRecord');

export type IssueReportAffectedRecord = z.infer<typeof issueReportAffectedRecordSchema>;
